import { getJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BASE_URL } from '../config/settings/environment'
import factoryAuthService from '../modules/requests/services'

/**
 * Gets the entity categories by the given identifiers, and year.
 */
export const getEntityCategories = factoryAuthService(({ entityId, familyId, segmentId, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/getTreeMap/getByFamily/${entityId}/${year}/${segmentId}/${familyId}`)
)

/**
 * Gets the entity families by the given identifiers, and year.
 */
export const getEntityFamilies = factoryAuthService(({ entityId, segmentId, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/getTreeMap/getBySegment/${entityId}/${year}/${segmentId}`)
)

/**
 * Gets the entity segments by the given entity, and year.
 */
export const getEntitySegments = factoryAuthService(({ entityId, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/getTreeMap/getSectors/${entityId}/${year}`)
)

/**
 * Gets the entity products by the given identifiers, and year.
 */
export const getEntityProducts = factoryAuthService(({ categoryId, entityId, familyId, segmentId, year }) =>
  getJsonRequest(
    `${REACT_APP_API_BASE_URL}/v1/getTreeMap/getByCategory/${entityId}/${year}/${segmentId}/${familyId}/${categoryId}`
  )
)
